export enum LOGIN_TYPE {
  EMAIL = 'email',
  MOBILE = 'mobile number',
}

export const LOGIN_HEADING = 'Log in or sign up';
export const OTP_PREFIX = 'Sent to';
export const EDIT_SIZE = '18px';
export const NAV_KEY = 'bn-auth';

export const ARIA_LABELS = {
  LOGIN_WITH_MOBILE: 'Login with mobile number',
  OTP_VERIFICATION: 'Enter OTP verification code',
  LOGIN_WITH_EMAIL: 'Login with email',
  LOGIN_DIALOG: 'Login dialog',
};
